import { format, parse } from 'date-fns';

import { CustomSerializer } from '@bonusly/schema';

// A custom serializer that converts date-only strings (ex YYYY-MM-DD) to JS Date objects (which include time).
// These use the user's current time as the default date, then apply the appropriate year, month, and day to it.
// This will allow for dates in the UI to display correctly in the user's time zone
export class DateOnlySerializer extends CustomSerializer {
	deserialize(data: string) {
		return data ? parse(data, 'yyyy-MM-dd', new Date()) : null;
	}

	serialize(data: Date) {
		return data ? format(data, 'yyyy-MM-dd') : null;
	}
}
